<template>
  <span class="tooltip-target" v-tooltip="tooltipOptions">
    <slot></slot>
  </span>
</template>

<script>
import { VTooltip } from "v-tooltip";

export default {
  name: "tooltip",

  directives: { tooltip: VTooltip },


  computed: {
    tooltipOptions() {
      return Object.assign({}, this.defaultOptions, this.options);
    },
    defaultOptions(){
        return {
            classes: "tooltip",
        }
      },
  },

  props: {
    options: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style lang="scss" src="./scss/index.scss"></style>
